import { z } from 'zod';
import { ACTIONS, ROLES, type ActionType, type RoleId } from './roles.js';

const RoleThemeSchema = z.object({
  name: z.string().min(1).max(40),
  blurb: z.string().max(200).default(''),
  /** Accent color for the card face. */
  color: z.string().regex(/^#[0-9a-fA-F]{6}$/),
  /** Single emoji or short glyph shown on the card until real art exists. */
  glyph: z.string().max(8).default('?'),
});

export const ThemeSchema = z.object({
  id: z.string().min(1).max(64),
  name: z.string().min(1).max(60),
  description: z.string().max(300).default(''),
  /** Short backstory shown to newcomers before the game — sets the mood. */
  intro: z.string().max(600).default(''),
  roles: z.object({
    financier: RoleThemeSchema,
    slayer: RoleThemeSchema,
    raider: RoleThemeSchema,
    broker: RoleThemeSchema,
    guardian: RoleThemeSchema,
  }),
  actions: z.object({
    income: z.string(),
    foreign_aid: z.string(),
    strike: z.string(),
    tax: z.string(),
    assassinate: z.string(),
    steal: z.string(),
    exchange: z.string(),
  }),
});
export type Theme = z.infer<typeof ThemeSchema>;

export function roleName(theme: Theme, role: RoleId): string {
  return theme.roles[role].name;
}
export function actionName(theme: Theme, action: ActionType): string {
  return theme.actions[action];
}

// Keep enum drift honest at compile time.
const _roles: readonly RoleId[] = ROLES;
const _actions: readonly ActionType[] = ACTIONS;
void _roles;
void _actions;
